import { reactive } from 'vue';

/**
 * 옛 대리 길이 막혔다는 응답(403 SESSION_NOT_ALLOWED + LEGACY_ACCESS_BLOCKED)을 마지막으로 받은 종류.
 * axios 응답 가로채기가 채우고, 고객 상세가 계정관리 탭에 안내·「서브 관리자로 접속」 버튼을 보인다(W6 B3).
 * 정리 배포(01-12 주)에서 옛 길과 함께 삭제.
 */
export const legacyBlockedState = reactive({ kind: '' });
